var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.001 34.548c0-11.681-9.484-21.165-21.165-21.165H22.164C10.483 13.383.999 22.867.999 34.548s9.484 21.164 21.165 21.164h2.203l.255 7.049a4.002 4.002 0 006.159 3.222L46.78 55.712h11.056c11.681 0 21.165-9.483 21.165-21.164zm-8 0c0 7.266-5.899 13.164-13.165 13.164h-12.23a4 4 0 00-2.161.634L32.363 55.46l-.141-3.893a4 4 0 00-3.997-3.855h-6.061c-7.266 0-13.165-5.898-13.165-13.164s5.899-13.165 13.165-13.165h35.672c7.266 0 13.165 5.899 13.165 13.165z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.259,
    cy: 35.037,
    r: 4.963
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 35.037,
    r: 4.963
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.741,
    cy: 35.037,
    r: 4.963
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngage);
export default __webpack_public_path__ + "static/media/engage.479a7892e189917e2b6e74c07bb86354.svg";
export { ForwardRef as ReactComponent };